import { RiskFactor, riskFactorColors } from "@keita/lanepatrol-sdk";

const defaultColor = "#DDDDDD";

export const getColor = (riskFactor?: RiskFactor) =>
  riskFactor ? riskFactorColors[riskFactor] : defaultColor;

export const getRiskColor = (riskFactor?: RiskFactor) =>
  riskFactor ? riskFactorColors[riskFactor] : defaultColor;

export const lightenColor = (hexColor: string, amount: number): string => {
  const normalizedHex = hexColor.replace("#", "");

  if (!/^[0-9a-fA-F]{6}$/.test(normalizedHex)) {
    return hexColor;
  }

  const red = parseInt(normalizedHex.slice(0, 2), 16);
  const green = parseInt(normalizedHex.slice(2, 4), 16);
  const blue = parseInt(normalizedHex.slice(4, 6), 16);

  const lightenChannel = (channel: number) =>
    Math.round(channel + (255 - channel) * amount);

  return `rgb(
    ${lightenChannel(red)},
    ${lightenChannel(green)},
    ${lightenChannel(blue)}
  )`;
};


export const formatRiskFactor = (riskFactor: RiskFactor) => {
  switch (riskFactor) {
    case RiskFactor.Low:
      return "Low";

    case RiskFactor.Medium:
      return "Medium";

    case RiskFactor.High:
      return "High";

    case RiskFactor.Extreme:
      return "Extreme";

    default:
      return "–";
  }
};